module.exports = __webpack_public_path__ + "static/media/Inactive_agencies.a0e284e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/Inactive_agencies.svg
// module id = 2699
// module chunks = 0